module.exports = __webpack_public_path__ + "static/img/map-1.6b46d620.png";